import { styled } from 'styled-components';

import { createResponsiveSpacingStyle, ResponsiveSpacing } from '../../../utils';

type RadioButtonGroupProps = {
  marginTop?: ResponsiveSpacing;
  marginRight?: ResponsiveSpacing;
  marginBottom?: ResponsiveSpacing;
  marginLeft?: ResponsiveSpacing;
  rowGap?: ResponsiveSpacing;
  children: React.ReactNode;
};

export const RadioButtonGroup = ({
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  rowGap = 20,
  children,
}: RadioButtonGroupProps) => (
  <Wrapper
    $marginTop={marginTop}
    $marginBottom={marginBottom}
    $marginRight={marginRight}
    $marginLeft={marginLeft}
    $rowGap={rowGap}
  >
    {children}
  </Wrapper>
);

const Wrapper = styled.fieldset<{
  $marginTop?: ResponsiveSpacing;
  $marginRight?: ResponsiveSpacing;
  $marginBottom?: ResponsiveSpacing;
  $marginLeft?: ResponsiveSpacing;
  $rowGap?: ResponsiveSpacing;
}>`
  /** Reset browser styling */
  border: 0;
  padding: 0.01em 0 0 0;
  margin: 0;
  min-width: 0;

  /** Add flex  */
  display: flex;
  flex-direction: column;
  ${props => props.$rowGap && `${createResponsiveSpacingStyle('row-gap', props.$rowGap)}`};
  ${props => props.$marginTop && `${createResponsiveSpacingStyle('margin-top', props.$marginTop)}`};
  ${props => props.$marginRight && `${createResponsiveSpacingStyle('margin-right', props.$marginRight)}`};
  ${props => props.$marginBottom && `${createResponsiveSpacingStyle('margin-bottom', props.$marginBottom)}`};
  ${props => props.$marginLeft && `${createResponsiveSpacingStyle('margin-left', props.$marginLeft)}`};
`;
